import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ReactComponent as IconRadioButtons } from 'assets/icon-radio-buttons-list.svg';
import { colors } from 'shared/defaultTheme';

const GroupOptions = ({
  className,
  title,
  color,
  onClick,
  options = [],
  titleClassName,
  selectedOption,
  showContainerIcon,
}) => {
  return (
    <div className={classNames(['group-options__main', className])}>
      <legend style={{ color }} className={classNames(['bold-Capitalize', titleClassName])}>
        {title}
      </legend>
      <div className="group-options__option-list">
        {showContainerIcon && (
          <div className="d-flex justify-content-xl-end group-options__container-icon">
            <IconRadioButtons className="group-options__icon" />
          </div>
        )}
        <ul className="list-unstyled" style={{ color: colors.black }}>
          {options.map((option) => (
            <li key={option.value} className="mb-3 d-flex align-items-center list-client__text">
              <input
                type="radio"
                onClick={() => onClick(option.value)}
                value={option.value}
                checked={option.value === selectedOption}
                onChange={() => null}
              />
              <span className="ml-2">{option.name}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

GroupOptions.defaultProps = {
  className: '',
  titleClassName: '',
  title: '',
  selectedOption: '',
  showContainerIcon: true,
};

GroupOptions.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string,
  titleClassName: PropTypes.string,
  color: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
    })
  ).isRequired,
  selectedOption: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showContainerIcon: PropTypes.bool,
};

export default GroupOptions;
